<template>
    <button v-bind:type="btnType" v-on:click.prevent="sendForm" v-bind:class="btnClass"> {{ btnText }} </button>
</template>

<script>
import {EventBus} from "../../EventBus";

export default {
        name: "FormSenderButton",
        props: {
            btnClass: {
                type: String,
                default: 'btn btn-light',
            },
            btnType: {
                type: String,
                default: 'submit',
            },
            btnText: {
                type: String,
                default: 'Send',
            },
            alertText: {
                type: String,
                default: 'Are you sure?',
            },
            formId: {
                type: String,
                required: true,
            }
        },
        methods: {
            sendForm: function() {
                let confirmation = false;
                if (!document.getElementById(this.formId).reportValidity()) {
                    return;
                }
                confirmation = confirm(this.alertText);
                if (confirmation) {
                    document.getElementById(this.formId).submit();
                    EventBus.emit('form-sent', this.formId);
                }
            }
        }
    }
</script>

<style scoped>

</style>
